module.exports = __webpack_public_path__ + "img/EXTERIOR-CIAZ-1.e1350277.jpg";